export const SECTION_KEYS = {
  HEADER: "header",
  FOOTER: "footer",
  NAVIGATION_BAR: "navigationBar",
  PAYMENT_HEADER: "paymentHeader",
  PAYMENT_HERO: "paymentHero",
  PAYMENT_CONTACT_ADDRESS: "paymentContactAddress",
  PAYMENT_REMARK_DELIVERY: "paymentRemarkDelivery",
  PAYMENT_METHODS: "paymentMethods",
  PAYMENT_CART_ITEMS: "paymentCartItems",
  PAYMENT_ORDER_SUMMARY: "paymentOrderSummary",
  PAYMENT_ADDRESS_PICKER: "paymentAddressPicker",
  USER_HEADER: "userHeader",
};

export default SECTION_KEYS;
